import { render, staticRenderFns } from "./BatchHeaderButton.vue?vue&type=template&id=5a6b3fae&scoped=true&"
import script from "./BatchHeaderButton.vue?vue&type=script&lang=js&"
export * from "./BatchHeaderButton.vue?vue&type=script&lang=js&"
import style0 from "./BatchHeaderButton.vue?vue&type=style&index=0&id=5a6b3fae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6b3fae",
  null
  
)

export default component.exports